import { useMemo } from 'react';

import { useTranslation } from '@shared/core';
import type { CarRatesSortDto } from '../CarRentalConsole.types';
import { CAR_RATES_SORT_OPTIONS } from '../CarRentalConsole.constants';

export const useCarSortOptions = () => {
  const { tq } = useTranslation('carRentalConsole');

  return useMemo<ReadonlyArray<{ value: CarRatesSortDto; label: string }>>(
    () =>
      CAR_RATES_SORT_OPTIONS.map(value => {
        switch (value) {
          case 'recommended':
            return { value, label: tq`Recommended` };
          case 'total_price':
            return { value, label: tq`Total price` };
          case 'distance':
            return { value, label: tq`Distance` };
          case 'customer_rating':
            return { value, label: tq`Customer rating` };
        }
      }),
    [tq],
  );
};
